// extracted by css-extract-rspack-plugin
export default {"banner":"ChatInputBanners-module__banner__KjIAn","gpt5":"ChatInputBanners-module__gpt5__Bt07p"};